import dayjs from 'dayjs';
import { getLocalDateTime } from '@sonar-software/sonar-ts-lib';
import { USER_NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';

export function getNotificationDisplayTime(timestamp: string): string {
	const now = dayjs();
	const local = getLocalDateTime(timestamp);
	const dayDiff = Math.floor(now.diff(local, 'day'));

	if (dayDiff > 30) {
		return local.format('MMM Do YYYY');
	}

	if (dayDiff === 7) {
		return USER_NOTIFICATIONS_COPY.WEEK_AGO;
	}

	if (dayDiff > 1) {
		return USER_NOTIFICATIONS_COPY.DAYS_AGO(dayDiff);
	}

	if (dayDiff === 1) {
		return USER_NOTIFICATIONS_COPY.DAY_AGO;
	}

	const hourDiff = Math.floor(now.diff(local, 'hour'));

	if (hourDiff === 1) {
		return USER_NOTIFICATIONS_COPY.HOUR_AGO;
	}

	if (hourDiff > 1) {
		return USER_NOTIFICATIONS_COPY.HOURS_AGO(hourDiff);
	}

	const minutesDiff = Math.floor(now.diff(local, 'minute'));

	if (minutesDiff === 1) {
		return USER_NOTIFICATIONS_COPY.MINUTE_AGO;
	}

	if (minutesDiff > 1) {
		return USER_NOTIFICATIONS_COPY.MINUTES_AGO(minutesDiff);
	}

	return USER_NOTIFICATIONS_COPY.LESS_MINUTE_AGO;
}
